import AppForm from '../app-components/Form/AppForm';

Vue.component('app-factory-transaction-form-import', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                name:  '' ,
                // admin_user_id:  '' ,
                // app_offices_id:  '' ,
                app_factories_id:  '' ,
                app_payment_id:  '' ,
                row_start:  1 ,
                read_sheet:  1 ,
                row_end:  1 ,
                column_maps:  [] ,
                factorySourceData:[],
                
            },
            // factorySourceData:[],
            tempFactory: null,
            headerPreview:  [] ,
            info:  {},
            payments:{
                type: Array,
                default:[
                ]
            }
        }
    },
    computed: {
        paymentVehicle: (app)=> (salut)=> {
            return app.payments[salut.F]||[]
        }
    },
    methods:{
        onUpdateFactory(appFactory) {
            if (appFactory !== null) {
                this.form.app_factories_id = appFactory.id;
            }else{
                this.form.app_factories_id = "";
            }
        },
        onRemoveFactory(appFactory) {
            this.form.app_factories_id = "";
        },
        uploadFile(evt){
            const superObj = this
            superObj.payments = []

            superObj.form.factorySourceData = []
            superObj.headerPreview = superObj.form.column_maps

            this.sourceFile = this.$refs.file.files[0]
            const formData = new FormData();
            formData.append('sourcefile', this.sourceFile);
            formData.append('app_factories_id', superObj.form.app_factories_id);
            formData.append('name', superObj.form.name);
            formData.append('row_start', superObj.form.row_start);
            formData.append('read_sheet', superObj.form.read_sheet);
            formData.append('row_end', superObj.form.row_end);
            formData.append('column_maps', JSON.stringify(superObj.form.column_maps));
            const headers = { 'Content-Type': 'multipart/form-data' };

            axios.post(`${this.actionUpload}`, formData, { headers }).then((res) => {

                const result = res.data
                const { data, info, payments } = result
                this.form.factorySourceData = data
                this.payments = payments
                this.info = info
            
            }).catch(function (error) {
                if (error.response) {
                    const { message, statusText } = error.response.data
                    const { message: axiosMessage } = error
                    superObj.$notify({
                        type: 'error',
                        title: 'Error!',
                        text: `${message} (${axiosMessage})`
                    });
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('Error', error.message);
                }
            
              });
        },
        resetFile(){
            // this.form.column_maps = []
            this.form.factorySourceData = []
            // this.$refs.fileupload.value = null;
            console.log('this.$refs.file', this.$refs.file)
            this.$refs.file.value = null
        }
    },
    props: {
        headersImport:{
            type: Array,
            default:[
            ]
        },
        actionUpload:{
            type: String,
            default:""
        },
    },
    mounted: function () {  
        this.form.column_maps = this.headersImport
        this.headerPreview = this.headersImport
    }

});